import { fromJS, Map } from 'immutable';

import * as Constants from '../constants';
import { AppActions, AppBgKeys, BgThemes } from '../constants/App';
import ViewActions from '../constants/ViewActions';
import { createReducer } from '../lib/ReducerUtils';
import createFilter from '../tools/ReduxPersistFilter';

const INITIAL_STATE = Map({
  mainSearch: Map({
    searchActive: false,
    hasFocus: false,
    autocompleteFocusIndex: -1,
    searchPreventBlur: false,
  }),
  addVarietySearch: Map({
    searchActive: false,
    hasFocus: false,
    autocompleteFocusIndex: -1,
    searchPreventBlur: false,
  }),
  [AppActions.SCROLLING_ENABLED]: true,
  [AppActions.BODY_SCROLLING_ENABLED]: true,
  [Constants.NowPlaying.NowPlayingKeys.IS_NEXT_TRACK_LOADING]: false,
  [Constants.Screen.ScreenKeys.IS_SCREEN_SMALL]: false,
  [Constants.Screen.ScreenKeys.CURRENT_SCREEN_WIDTH]: 0,
  [Constants.Screen.ScreenKeys.CURRENT_SCREEN_HEIGHT]: 0,
  [Constants.Station.StationConstants.IS_STATION_LIST_HOVERED]: false,
  [AppBgKeys.APP_BG]: Map({
    [AppBgKeys.BG_THEME]: BgThemes.DEFAULT,
    [AppBgKeys.NAV_THEME]: 'light',
  }),
  [AppBgKeys.DOMINANT_COLOR]: null,
});

// UI REDUCER
export default createReducer(INITIAL_STATE, {
  [AppActions.APPLICATION_BACKGROUND_UPDATE]: applicationBackgroundUpdate,
  [AppActions.UPDATE_DOMINANT_COLOR]: dominantColorUpdate,
  [Constants.Search.SearchActions.SEARCH_UI_UPDATE]: searchUiUpdate,
  [AppActions.ENABLE_SCROLLING]: enableScrolling,
  [AppActions.DISABLE_SCROLLING]: disableScrolling,
  [AppActions.ENABLE_BODY_SCROLLING]: enableBodyScrolling,
  [AppActions.DISABLE_BODY_SCROLLING]: disableBodyScrolling,
  [Constants.UseCases.ActionTypes.SKIP_TRACK_FORWARD]: trackLoading,
  [Constants.Api.ApiActions.EVENT_ENDED_ATTEMPT]: trackLoading,
  [Constants.Playback.ActionTypes.ADD_TRACK_TO_STATION_HISTORY]: trackNotLoading,
  [Constants.Integrations.ActionTypes.TRACK_STARTED_FROM_SOURCE]: trackNotLoading,
  [Constants.Ads.Rewards.ActionTypes.SET_OPEN_COACHMARK]: trackNotLoading,
  [Constants.Overlay.OVERLAY_ACTIONS.OPEN_OVERLAY]: trackNotLoading,
  [Constants.Screen.ScreenActions.SET_SMALL_SCREEN_UI]: setSmallScreenUi,
  [Constants.Screen.ScreenActions.SET_CURRENT_SCREEN_DIMENSIONS]: setCurrentScreenDimensions,
  [ViewActions.HOVERED_OVER_STATION_LIST]: hoveredOverStationList,
  [ViewActions.HOVERED_OUT_STATION_LIST]: hoveredOutStationList,
  [Constants.UseCases.ActionTypes.SKIP_TRACK_FORWARD_CANCEL]: trackNotLoading,
  [Constants.Api.ApiActions.LOGOUT_SUCCESS]: clearUIData,
  [Constants.Playback.APSActions.PLAY_AD_ITEM]: trackNotLoading,
});

export const UIFilter = createFilter({
  reducer: 'ui',
  keys: [AppBgKeys.DOMINANT_COLOR, AppBgKeys.APP_BG],
  defaults: INITIAL_STATE,
});

// CASE FUNCTIONS

function applicationBackgroundUpdate(state, { payload }) {
  return state.set(AppBgKeys.APP_BG, fromJS(payload));
}

function dominantColorUpdate(state, { payload }) {
  return state.set(AppBgKeys.DOMINANT_COLOR, payload.color);
}

function searchUiUpdate(state, { payload }) {
  return state.mergeIn([payload.searchType], payload);
}

function enableScrolling(state) {
  return state.set(AppActions.SCROLLING_ENABLED, true);
}

function disableScrolling(state) {
  return state.set(AppActions.SCROLLING_ENABLED, false);
}

function enableBodyScrolling(state) {
  return state.set(AppActions.BODY_SCROLLING_ENABLED, true);
}

function disableBodyScrolling(state) {
  return state.set(AppActions.BODY_SCROLLING_ENABLED, false);
}

function trackLoading(state) {
  return state.set(Constants.NowPlaying.NowPlayingKeys.IS_NEXT_TRACK_LOADING, true);
}

function trackNotLoading(state) {
  return state.set(Constants.NowPlaying.NowPlayingKeys.IS_NEXT_TRACK_LOADING, false);
}

function setSmallScreenUi(state, action) {
  return state.set(Constants.Screen.ScreenKeys.IS_SCREEN_SMALL, action.data);
}

function setCurrentScreenDimensions(state, action) {
  return state.merge({
    [Constants.Screen.ScreenKeys.CURRENT_SCREEN_WIDTH]: action.data.screenWidth,
    [Constants.Screen.ScreenKeys.CURRENT_SCREEN_HEIGHT]: action.data.screenHeight,
  });
}

function hoveredOverStationList(state) {
  return state.set(Constants.Station.StationConstants.IS_STATION_LIST_HOVERED, true);
}

function hoveredOutStationList(state) {
  return state.set(Constants.Station.StationConstants.IS_STATION_LIST_HOVERED, false);
}

function clearUIData(state) {
  return INITIAL_STATE;
}
